import { useEffect, useState } from 'react';
import { select } from 'd3-selection';
import { pointer } from '@d3fc/d3fc-pointer';
import { useXAxisContext } from './XAxisContext';
import { TimePointer, TimePointerState } from './TimePointer';
import { timeUtils } from '@instinet-analytics/core-lib';

const { round } = timeUtils;

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */

interface PointEvent {
    x: number;
}

export function applyPointer(timePointer: TimePointer) {
    return (node: any, isDomainValid: boolean, xScale: any) => {
        const p = pointer().on('point', (events: PointEvent[]) => {
            if (isDomainValid && xScale && events.length === 1) {
                const x = events[0].x;
                let time = xScale.invert(x);
                if (time instanceof Date) {
                    time = time.getTime();
                }
                time = round(time, 'minute');
                timePointer.publish({ x, time });
            } else {
                timePointer.publish({ x: undefined, time: undefined });
            }
        });
        select(node).select('.plot-area').call(p);
    };
}

export function usePointedTime(id: string) {
    const xAxisContext = useXAxisContext();
    const { timePointerRef } = xAxisContext;
    const [pointedTime, setPointedTime] = useState<number | undefined>();
    useEffect(() => {
        if (timePointerRef.current) {
            const unsubscribe = timePointerRef.current.subscribe(
                id,
                (context?: TimePointerState) =>
                    setPointedTime(context && context.time)
            );
            return () => unsubscribe();
        }
    }, [id, timePointerRef.current]);
    return pointedTime;
}
